<template>
    <div :class="col">
        <div class="form-group mb-3">
            <label :for="id">
                <span class="text-truncate">
                    {{title}}
                </span>
                <i v-if="required == 'true'" class="fas fa-shield-alt"></i>
            </label>
            <div class="container">
                <select v-if="options" :id="id ? id : name" :disabled="Boolean(disabled)" :multiple="multiple" v-model="selected"  :class="clases" :required="required"
                    v-on:input="$emit('input', $event.target.value)" :name="name ? name : id" :data-actions-box="dataBox" >
                    <option hidden value='' disabled :selected="value === null">Seleccionar...</option>
                    <option hidden value="" disabled :selected="value === undefined">Seleccionar...</option>
                    <option v-for="option in options" :key="option.id" :value="option.id" :selected="value === option.id">{{option.text}}</option>
                </select>
                <select v-else :id="id ? id: name" :disabled="Boolean(disabled)" :multiple="multiple" :class="clases" v-on:input="$emit('input', $event.target.value)"
                    v-model="selected" :required="required == 'true'" :name="name ? name : id" :data-actions-box="dataBox">
                    <!-- <option hidden value='' disabled :selected="value === ''">Seleccionar...</option>
                    <option hidden value=0 disabled :selected="value === null">Seleccionar...</option> -->
                    <option hidden value="" disabled :selected="value === null">Seleccionar...</option>
                    <option hidden value="" disabled :selected="value === undefined">Seleccionar...</option>
                    <option v-for="option in data" :key="option.id" :value="option.id" :selected="value === option.id">{{option.text}}</option>
                </select>
                <button v-if="value && (!clean || clean == 'true')" class="btn btn-sm btn-remover-opcion" type="button" @click="$emit('input', undefined)">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    props: [
        'id',
        'title',
        'value',
        'clean',
        'get',
        'default',
        'parent',
        'expanded',
        'required',
        'options',
        'name',
        'force',
        'disabled',
        'styles',
        'multiple',
        'dataBox',
        'parentStyles'
    ],
    data() { return {
        data: [],
        col: 'col-xs-12 col-md-6 col-lg-4 component-kira-select',
        firstTime: true,
        selected: [],
        clases: 'form-control text-truncate'
    }},
    mounted() {
        const vm = this;
        if (this.parentStyles){
            this.col = this.parentStyles
        }
        if (this.styles) {
            this.clases = this.styles
        }

        if(this.expanded && this.expanded == 'true') {
            this.col = 'col-12';
        }

        if(this.options == undefined) {
            this.$parent.$on('broadcastOpenModal', function(createMode) {
                //console.log(vm.id, 'valor', vm.value);
                if(vm.value != undefined) {
                    vm.getM(vm.get, createMode);
                }
                //vm.$emit('input', '');
            });
        }

        //if(this.othis.parentStylesptions == undefined) {
            this.$parent.$on('broadcastRefreshSelection', function(who, val) {
                if(who == vm.parent && who != undefined) {
                    if(val == undefined) {
                        vm.data = [];
                        vm.$emit('input', undefined);
                    } else {
                        vm.getM(vm.get);
                        if(vm.firstTime) {
                            vm.firstTime = false;
                        } else {
                            vm.$emit('input', undefined);
                        }

                    }
                }
                /* if(who == vm.parent) {
                    console.log(vm.id, ' me vuelvo a cargar pues cambió:', who, 'a:', val)
                    if(val == 'null') {
                        console.log('es nulo');
                        vm.$emit('input', 'null');
                    }
                    if(val != null) {
                        vm.getM(vm.get);
                    }
                } */
            });

            this.$parent.$on('broadcastCloseModal', function() {
                //vm.$emit('input', undefined);
            });

            if(this.force) {
                vm.getM(vm.get);
            }

            if (this.clases && this.clases.includes('selectpicker')){
                console.log(this.value)
                if (Array.isArray(this.value)){
                    setTimeout(()=>{
                        $(`#${vm.id}`).selectpicker('val', vm.value);
                    }, 500)
                }
                $(`#${this.id}`).change(function(){
                    vm.selected = $(`#${vm.id}`).val() || []
                    vm.$emit('input', $(`#${vm.id}`).val());
                });
            }

            /* if(this.parent != undefined) {
                console.log('soy', vm.id);
                vm.$parent.$on('broadcastFormReady', function() {
                    console.log('el valor es:', vm.get);
                    vm.getM(vm.get);
                });
            } */
        //}

        if(this.get != undefined && this.parent == undefined) {
            vm.getM(vm.get);
        }

        /* if(this.get != undefined && this.parent == undefined) {
            console.log('una sola vez');
            vm.getM(vm.get);
        } */
    },
    methods: {
        getM: function(url, createMode) {
            const vm = this
            Axios.get(url).then(res => {
                this.data = res.data;
                if (this.clases && this.clases.includes('selectpicker')){
                    setTimeout(()=>{
                        $(`#${vm.id}`).selectpicker('refresh');
                    },500)
                }
                if(createMode == true) {
                    if(this.default == undefined) {
                        //this.$emit('input', null);
                    } else {
                        //this.$emit('input', Number(this.default));
                    }
                }
            });
        },
    },
    watch: {
        value(newVal, oldVal){
            this.$parent.$emit('emitRefreshSelection', this.id, newVal);
            this.selected = this.multiple ? newVal || [] : newVal
            //console.log(this.id, 'dice old val:', oldVal, 'new val:', newVal);
            /* if(oldVal !== undefined && this.id != undefined) {
                this.$parent.$emit('emitRefreshSelection', this.id, newVal);
            } else if(oldVal == null) {
                //console.log('si es vacio null');
                //this.$emit('input', 'null');
            } */
        },
    }
}
</script>
